// Enter all your detials in this file
// Logo images
import logogradient from "./assets/logo.svg";
import logo from "./assets/logo2.svg";
// Profile Image
import profile from "./assets/profile.jpg";
// Tech stack images
import html from "./assets/techstack/html.png";
import css from "./assets/techstack/css.png";
// import sass from "./assets/techstack/sass.png";
import js from "./assets/techstack/js.png";
import react from "./assets/techstack/react.png";
import flask from "./assets/techstack/flask.png";
// import tailwind from "./assets/techstack/tailwind.png";
import bootstrap from "./assets/techstack/bootstrap.png";
import vscode from "./assets/techstack/vscode.png";
import github from "./assets/techstack/github.png";
import git from "./assets/techstack/git.png";
import npm from "./assets/techstack/npm.png";
import photoshop from "./assets/techstack/photoshop.png";
import figma from "./assets/techstack/figma.png";
import angular from "./assets/techstack/angular.png";
import premierepro from "./assets/techstack/premierepro.png";
import illustrator from "./assets/techstack/illustrator.png";
import python from "./assets/techstack/python.png";
import xamarin from "./assets/techstack/xamarin.png";
import nodejs from "./assets/techstack/nodejs.png";
// Porject Images
import projectImage1 from "./assets/projects/project1.jpg";
import projectImage2 from "./assets/projects/project2.jpg";
// import projectImage3 from "./assets/projects/project3.jpg";
// import projectImage4 from "./assets/projects/project4.jpg";
// import projectImage5 from "./assets/projects/project5.jpg";
// import projectImage6 from "./assets/projects/project6.jpg";

// Logos
export const logos = {
  logogradient: logogradient,
  logo: logo,
};

// Enter your Personal Details here
export const personalDetails = {
  name: "Subhash Nandhakumar",
  tagline: "i'm a Software Dev",
  img: profile,
  about: `I'm a dedicated software developer with expertise in crafting efficient solutions using modern technologies. I enjoy solving complex problems, optimizing systems, and continuously learning to stay ahead in the tech world. Let's connect and create something amazing!`,
};

// Enter your Social Media URLs here
export const socialMediaUrl = {
  linkdein: "https://www.linkedin.com/in/nsubhash",
  github: "https://www.github.com/nsubhash311",
  instagram: "https://www.instagram.com/subhash_311",
};

// Enter your Work Experience here
export const workDetails = [
  {
    Position: "Assistant System Engineer",
    Company: `Tata Consultancy Services`,
    Location: "Chennai, India",
    Type: "Full Time",
    Duration: "Jul 2022 - Jul 2023",
  },
  {
    Position: "Software Developer",
    Company: `VScaleUp`,
    Location: "Pondicherry, India",
    Type: "Internship",
    Duration: "Sep 2021 - Jun 2022",
  },
  {
    Position: "Software Developer Intern",
    Company: `Tata Consultancy Services`,
    Location: "Chennai, India",
    Type: "Internship",
    Duration: "Jun 2021 - Aug 2021",
  },
];

// Enter your Education Details here
export const eduDetails = [
  {
    Position: "Masters in Applied Computing",
    Company: "Wilfrid Laurier University",
    Location: "Waterloo, Ontario, Canada",
    Type: "Full Time",
    Duration: "Sep 2023 - Dec 2024",
  },
  {
    Position: "Bachelor in Computer Science",
    Company: `Sri Manakula Vinayagar Engineering College`,
    Location: "Pondicherry, India",
    Type: "Full Time",
    Duration: "Aug 2018 - May 2022",
  },
];

// Tech Stack and Tools
export const techStackDetails = {
  html: html,
  css: css,
  js: js,
  react: react,
  bootstrap: bootstrap,
  angular: angular,
  flask:flask,
  vscode: vscode,
  photoshop: photoshop,
  npm: npm,
  git: git,
  github: github,
  figma: figma,
  illustrator: illustrator,
  premierepro: premierepro,
  python: python,
  xamarin: xamarin,
  nodejs: nodejs,
};

// Enter your Project Details here
export const projectDetails = [
  {
    title: "PTSD Detection using BERT Models",
    image: projectImage1,
    description: `Developed a system to detect PTSD indicators in clinical text using BERT and its variants. The project involved comprehensive data preprocessing and fine-tuning models to achieve high validation accuracies (93-95%) across multiple BERT configurations.
`,
    techstack: "Python, Machine Learning",
    Link: "https://medium.com/@subhashnandhakumar311/revolutionizing-ptsd-detection-with-bert-a-step-towards-better-mental-health-support-c83fe894674d",
    // githubLink: "https://github.com",
  },
  {
    title: "Sarvatrika",
    image: projectImage2,
    description: `An universal prediction model where it does everything in automation which predicts values of any numerical dataset. Machine learning-powered service that enables users to view an analyzed prediction of their commercial data that helps even small scale businesses to utilize ML.`,
    techstack: "JavaScript, Python, Machine Learning, HTML/CSS",
    // Link: "https://google.com",
    Link: "https://github.com/nsubhash311/Sarvatrika-V-2",
  },
//   {
//     title: "Project title 3",
//     image: projectImage3,
//     description: `This is sample project description random things are here in description This is sample
// project lorem ipsum generator for dummy content`,
//     techstack: "HTML/CSS, JavaScript",
//     previewLink: "https://google.com",
//     githubLink: "https://github.com",
//   },
//   {
//     title: "Project title 4",
//     image: projectImage4,
//     description: `This is sample project description random things are here in description This is sample
// project lorem ipsum generator for dummy content`,
//     techstack: "HTML/CSS, JavaScript",
//     previewLink: "https://google.com",
//     githubLink: "https://github.com",
//   },
//   {
//     title: "Project title 5",
//     image: projectImage5,
//     description: `This is sample project description random things are here in description This is sample
// project lorem ipsum generator for dummy content`,
//     techstack: "HTML/CSS, JavaScript",
//     previewLink: "https://google.com",
//     githubLink: "https://github.com",
//   },
//   {
//     title: "Project title 6",
//     image: projectImage6,
//     description: `This is sample project description random things are here in description This is sample
// project lorem ipsum generator for dummy content`,
//     techstack: "HTML/CSS, JavaScript",
//     previewLink: "https://google.com",
//     githubLink: "https://github.com",
//   },
];

// Enter your Contact Details here
export const contactDetails = {
  email: "subhashnandhakumar311@gmail.com",
  phone: "+1 1234567890",
};
